import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  notifications: [],
  history: [],
  loading: false,
  error: null,
};

const NotificationSlice = createSlice({
  name: "Notification",
  initialState,
  reducers: {
    apiResponseSuccess: (state, action) => {
      switch (action.payload.actionType) {
        case "GET_NOTIFICATIONS":
          state.notifications = action.payload.data;
          break;
        case "GET_HISTORY":
          state.history = Array.isArray(action.payload.data) ? action.payload.data : [];
          break;
        case "ADD_NOTIFICATION":
          state.history = [action.payload.data, ...(Array.isArray(state.history) ? state.history : [])];
          break;
        case "MARK_READ":
          state.notifications = state.notifications.map(n => 
            n._id === action.payload.data ? { ...n, readBy: [...n.readBy, action.payload.userId] } : n
          );
          break;
        default:
          break;
      }
      state.loading = false;
    },
    apiResponseError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    loadingStart: (state) => {
      state.loading = true;
    },
  },
});

export const { apiResponseSuccess, apiResponseError, loadingStart } = NotificationSlice.actions;
export default NotificationSlice.reducer;
